
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <div class="layout__bodycol">
        <header class="central-header">
          <div class="central-header__title">
            <a href="javascript:;"  routerLink="/everything.policy-holders" class="central-header__title-icon d-none d-lg-block">
              <svg class="icon">
                <use xlink:href="#arrow-left-small"></use>
              </svg>
            </a>
            <h3 class="font-normal">Compliance Vault</h3>
          </div>
          <div class="central-header__actions">
            <a href="#upload-file-modal" (click)="openUploadModal()" data-toggle="modal" class="button button--primary button--icon-only d-md-none">
              <svg class="icon"><use xlink:href="#plus"></use></svg>
            </a>
            <a href="#upload-file-modal" (click)="openUploadModal()" data-toggle="modal" class="button button--md button--primary d-none d-md-inline-block">Upload file</a>
          </div>
        </header>
        <div class="central-filter">
          <div class="central-filter__label">              
            <div class="central-filter__filter  ml-0">
              <div class="dropdown dropdown--central dropdown--persist" id="brokerage-dropdown">
              <a href="#" tabindex="0"  class="dropdown-toggle dropdown-toggle--grey" data-toggle="dropdown" aria-expanded="false">
                Filter
              </a>
              <div class="dropdown-menu dropdown-menu-left filter-list__scrollable" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 14px, 0px); top: 0px; left: 0px; will-change: transform;">  
                  <div class="filter-list__content">
                    <ul class="filter-list filter-list--central list-unstyled" id="brokerage-filter-list">
                        <li>
                          <label class="custom-input custom-input--radio">
                              <input type="radio" checked="" (change)="setfilter('all')" value="all" name="brokerage-filter[]">
                              <span class="custom-input__indi"></span>
                              <span class="custom-input__label">All</span>
                          </label>
                        </li>
                        <li *ngFor="let filter of filters">
                          <label class="custom-input custom-input--radio">
                              <input type="radio" value="{{filter}}" (change)="setfilter(filter)" name="brokerage-filter[]">
                              <span class="custom-input__indi"></span>
                              <span class="custom-input__label">{{filter}}</span>
                          </label>
                        </li>
                       
                    </ul>
                  </div>
                  <div class="filter-list__button">
                    <a href="javascript:;" class="button button--primary button--block dropdown-toggle">Apply</a>
                 </div> 
                </div>
              </div>
            </div>
          </div>    
          <div class="central-filter__controls">

            <div class="central-filter__trigger is-active" id="search-trigger">
              <svg class="icon"><use xlink:href="#search-small"></use></svg>
            </div>
            <div class="central-filter__search" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" [(ngModel)]="search_query" placeholder="Search" (ngModelChange)="searchChange()" id="search-input" autocomplete="off" class="form-control form-control--sm">
               
                <a href="#" id="search-clear" (click)="searchChange()" class="form-control__clear"><svg class="icon"><use xlink:href="#close-circle-small"></use></svg></a>
              </div>
            </div>
            <!-- <div class="central-filter__trigger is-active" id="table-search-trigger">
              <svg class="icon">
                <use xlink:href="#search-small"></use>
              </svg>
            </div>
            <div class="central-filter__search" id="table-search-container">
              <div class="form-control__wrap has-clear">
                <input
                  type="search"
                  placeholder="Search"
                  autocomplete="none"
                  [(ngModel)]="search_query"
                  (keydown.enter)="searchChange()"
                  class="form-control form-control--sm"/>
                <a href="javascript:void(0);" id="table-search-clear" class="form-control__clear"
                   (click)="clearSearch()">
                  <svg class="icon">
                    <use xlink:href="#close-circle-small"></use>
                  </svg>
                </a>
              </div>
            </div> -->

          </div>          
        </div>
        <div *ngIf="filtered?.length > 0" class="table__wrap table__wrap--broker table-responsive" id="table-wrap">
          <table datatable [dtOptions]="dtOptions" role="grid" [dtTrigger]="dtTrigger" class="table table--broker table--broker-quotes dataTable no-footer"
                 id="broker-table" style="width: 100% !important;">
            <thead>
            <tr role="row">
              <th class="cell-sticky cell-sticky--left">
                Display Name
                <a href="javascript:;" class="table__sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
             <th style="max-width: 100px;">Description</th>
             <th>Original Filename</th>
             <th>Type</th>
             <th>Size</th>
             <th>Uploaded By</th>
             <th>Item</th>
              <th class="cell-sticky cell-sticky--right cell-sticky--actions">&nbsp;</th>
              <th class="cell-sticky">&nbsp;</th>
            </tr>
            </thead>

            <tbody id="table-content" [ngClass]="{'hide-table-content': !files?.length}">
            <tr *ngFor="let file of filtered;" >
              <td class="cell-sticky cell-sticky--left">{{file?.display_name}}</td>
              <td style="max-width: 500px;text-wrap: wrap;">{{file?.description}}</td>
              <td>{{file?.original_filename}}</td>
              <td>{{file?.extension}}</td>
              <td>{{(file?.file_size/1000) | number : '1.0-0' }} KB</td>
              <td>{{file?.uploadedby}}</td>
              <td>{{file?.item}}</td>
              <td class="has-action text-right cell-sticky cell-sticky--right cell-sticky--actions">
                <!-- <a
                  *ngIf="!person?.underwriter"
                  href="#modal-notes-notify"
                  data-toggle="modal"
                  class="icon-hover icon-hover--slim icon-hover--alt">
                  <svg class="icon">
                    <use xlink:href="#notifications-small"></use>
                  </svg>
                </a>
                <a
                  href="javascript:void(0);"
                  class="icon-hover icon-hover--slim icon-hover--alt" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="4 Conditions">
                  <svg class="icon">
                    <use xlink:href="#warning-small"></use>
                  </svg>
                </a> -->
              </td>
              <td class="has-action cell-min cell-sticky">
                <div  class="dropdown">
                  <a href="javascript:void(0);"
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-none d-md-block"
                     data-toggle="dropdown">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  
                  <a href="#modal-traymenu-actions" (click)="setFile(file)" 
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none"
                     data-toggle="modal">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  
                  <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
                       <a href="javascript:void(0);" (click)="viewFile(file)" class="dropdown-item" data-sortby="best_value">
                        <svg class="icon">
                          <use xlink:href="#eye"></use>
                        </svg>
                        <span>View</span>
                      </a>
                       <a href="javascript:void(0);" (click)="downloadFile(file)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#download"></use>
                      </svg>
                      <span>Download</span>
                    </a>
                    <a href="javascript:void(0);" (click)="editFile(file)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#edit"></use>
                      </svg>
                      <span>Edit</span>
                    </a>
                    <a class="dropdown-item" href="#confirm-modal" data-toggle="modal"  (click)="setFile(file)" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#trash"></use>
                      </svg>
                      <span>Delete</span>
                    </a>
                   
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="files?.length === 0" class="table-noresults table-noresults--vault is-active" id="demo-noresults">
          <div class="table-noresults__content">                
            <img src="/assets/img/upload.svg" alt="" class="img-fluid">
            <h4 class="font-normal">This complaince vault is empty. </h4>
            <p>Click ‘Upload File’ to store any important files for this client here.</p>
          </div>
        </div>
        <div *ngIf="filtered?.length === 0 && files?.length > 0" class="table-noresults table-noresults--vault is-active">
          <div class="table-noresults__content">
             <img src="/assets/0/img/home/unsure.svg" alt="" class="img-fluid">
             <h3 class="font-normal">No results found</h3>
             <p>Try adjusting your search to find what you’re looking for.</p>
          </div>
          </div>
      </div>
    </div>
  </div>
</main>

<app-disclaimer></app-disclaimer>
<!-- <div class="modal fade modal--video" id="video-modal" tabindex="-1" role="dialog" aria-labelledby="video-modal" aria-modal="true">
  <div class="modal-dialog" role="document">

     <div class="modal-content modal-video">

        <header class="modal-video__header">
           <button class="modal-video__close" data-dismiss="modal">
              <svg class="icon">
                 <use xlink:href="#close-medium"></use>
              </svg>
           </button>
        </header>
        
        <div class="modal-video__content">
          <div class="embed-responsive embed-responsive-16by9">
          <video width="640" [src]="url" controls>
            Your browser does not support HTML video.
          </video>
          </div>
        </div>
     </div>
  </div>
</div> -->
<div class="modal fade modal--alert" id="upload-file-modal" tabindex="-1" role="dialog" aria-labelledby="upload-file-modal" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
     
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="#" class="modal-alert__close" data-dismiss="modal">
           <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
        
      <div class="modal-alert__content">
        <div class="container">              
          <div class="rte">
            <h3>{{ isEdit ? 'Edit file': 'Upload a file here'}}</h3>           
          </div>     

           <div class="form-group">
             <input type="text" [value]="selectedFile?.display_name" (change)="setMetaData()" [(ngModel)]="display_name"  placeholder="File Name" class="form-control">
           </div>

           <div class="form-group">               
              <textarea rows="4" class="form-control" (change)="setMetaData()" [(ngModel)]="description" placeholder="Description">{{selectedFile?.description}}</textarea>
           </div>
           
           <div *ngIf="!isEdit" class="form-group form-group--sm ui-front">  
           <select name="class-item" id="class-item" class="ui-selectmenu">
            <option value="">Select Item</option>
            <option *ngFor="let item of items" [attr.data-class-id]="item?.class_id" [value]="item?.session_item_id">{{item?.description_2}}</option>
          </select>
          </div>
          <ng-container *ngIf="isEdit">
            <video width="450" *ngIf="isVideo()" [src]="url" controls>
              Your browser does not support HTML video.
            </video>
            <img *ngIf="isImage()" [src]="url" class="img-fluid">
          </ng-container>
          <div *ngIf="!isEdit" class="form-group mb-10">
            <app-question-upload [showLabel]="false"
              [showNoteText]="false"
              [uploadLabelText]=""
              [question]="question"
              [queryParam]="metadata_json"
              [acceptedFileTypes] = "'application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
              (questionAnswer)="getUpload($event)">
            </app-question-upload>
          </div>
           
        </div>
      </div>
      
      <div class="modal-alert__button">
        <div class="container">                      
          <a href="javascript:;" *ngIf="!isEdit" data-dismiss="modal" (click)="upload()" class="button button--lg button--primary" id="btn-upload-done">Upload</a>
          <a href="javascript:;" *ngIf="isEdit" data-dismiss="modal" (click)="updateFile()" class="button button--lg button--primary">Update</a>
        </div>
      </div> 
      
      
    </div>
  </div>
</div>
<div class="modal fade modal--max modal--widest" id="view-modal" tabindex="-1" role="dialog" aria-labelledby="view-modal" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
     
     <div class="modal-alert__heading pb-1">
        <div class="container">          
          <a href="#" class="modal-alert__close" data-dismiss="modal">
           <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
        
      <div class="modal-alert__content">
        <div class="container">              
          <div class="rte">
            <h4>{{getDisply(selectedFile?.metadata_json,'display_name')}}</h4>      
            <p>{{getDisply(selectedFile?.metadata_json,'description')}}</p>     
          </div> 
        </div>
        <video width="630" *ngIf="isVideo()" [src]="url" controls>
          Your browser does not support HTML video.
        </video>
        <img *ngIf="isImage()" [src]="url" class="img-fluid">
        <iframe style="width: 100%; height: 450px; border: 0px solid" *ngIf="selectedFile?.extension.toLowerCase() === '.pdf'" [src]="url | safeUrl" ></iframe>
      </div>
    </div>
  </div>
</div>
<div *ngIf="false" class="modal fade modal--alert" tabindex="-1" role="dialog"
     aria-labelledby="pause-summary-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Which view would you like to use?</h4>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" routerLink="/everything.policy-overview" id="pause-summary-no"
             class="button button--lg button--primary" data-dismiss="modal">Broker</a>

          <a href="javascript:void(0);" routerLink="/everything.underwriter-landing" id="pause-summary-no"
             class="button button--lg button--secondary" data-dismiss="modal">Underwriter</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--note" id="modal-notes-notify" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-note">
      <div class="modal-note__heading">
        <div class="container">
          <h5>Notes</h5>
          <button class="modal-note__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-note__content">
        <div class="container">
          <div class="notetree">
            <div class="notetree__item">
              <div class="notetree__item-branch">
                <svg class="icon">
                  <use xlink:href="#note-filled"></use>
                </svg>
              </div>
              <div class="notetree__item-content">
                <div class="notetree__item-title">
                  <h5>Lia Bhardvaj</h5>
                  <time>July 23, 2020</time>
                </div>
                <div class="rte">
                  <p>[Message from UW to Broker: Vestibulum pellentesque ex tortor, pellentesque lacinia elit efficitur
                    in. Ut dignissim ac justo at aliquam. Donec et commodo nulla. Proin quis ex ac ligula laoreet.]</p>
                </div>
                <div class="tag-pill__list mt-10">
                  <a href="javascript:void(0);" class="tag-pill tag-pill--file">
                    <svg class="icon">
                      <use xlink:href="#attachment"></use>
                    </svg>
                    [filename].pdf</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- mobile menu modal -->
<div class="modal fade modal--fullscreen" id="mobile-quote-menu" tabindex="-1" role="dialog"
     aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-everything">
      <div class="modal-everything__header">
        <div class="container">
          <div class="modal-everything__title">
            Our Products
          </div>
          <button type="button" data-dismiss="modal" aria-label="Close" class="modal-everything__close">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-everything__content">
        <div class="container">
          <ul class="everything-categories-mobile list-unstyled">
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism"></svg-icon>
              </a>
            </li>
            <li>
              <div class="everything-categories-mobile__item everything-categories-mobile__item--unsure">
                <p><strong>Unsure?</strong></p>
                <p><a href="javascript:void(0);"><strong>Let us help you</strong></a></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-everything__actions">
        <div class="container">
          <button class="button button--block button--secondary">Login</button>
          <button class="button button--block button--primary-gradient">Get a Quote</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
<!-- help modal -->
<div class="modal fade modal--max" id="help-modal" tabindex="-1" role="dialog" aria-labelledby="help-modal"
     aria-hidden="true">
  <div class="modal-dialog modal-help" role="document">
    <div class="modal-content modal-help__inner">
      <header class="modal-help__header">
        <a href="javascript:void(0);" class="modal-help__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
          <span>Back</span>
        </a>
        <a href="javascript:void(0);" class="modal-help__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </header>
      <div class="modal-help__content">
        <div class="container">

          <div class="modal-help__title">
            <h2 class="font-serif">What do you want to insure?</h2>
          </div>


          <div class="modal-help__categories is-active">
            <p>Our products extend to every facet of life, from personal home and car, to business assets, professional
              indemnity, to death and disability cover as well as travel insurance. Whatever your insurance needs, we’ve
              got you covered.</p>

            <!-- add everything-categories--extended for max 4 products per row -->
            <ul class="everything-categories list-unstyled">
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you own in a business from assets to liability cover.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-business">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-business"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to do with your general life and risks you face. </p>
                  </div>
                  <div class="everything-categories__item-btn text-color-life">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-life"></div>
                </a>
              </li>
              <li>
                <a href="#product-personal" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you care about and own in your personal capacity.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-personal">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-personal"></div>
                </a>
              </li>
              <li>
                <a href="#product-professional" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to insure you as a professional in the event that you get sued.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item everything-categories__item--unsure">
                  <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
                  <p><strong>Unsure what insurance you need?</strong></p>
                  <p><span class="link"><strong>Let us help you</strong></span></p>
                </a>
              </li>
            </ul>

          </div>

          <div class="modal-help__products">
            <ul class="everything-products everything-products--personal list-unstyled" id="product-personal">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
            </ul>
            <ul class="everything-products everything-products--professional list-unstyled" id="product-professional">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>SME Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
            </ul>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
<!-- /modal -->
<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-traymenu-actions" tabindex="-1" role="dialog"
     aria-labelledby="modal-traymenu-more" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:void(0);" data-dismiss="modal" (click)="viewFile(selectedFile)" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#eye"></use>
            </svg>
            <div>View</div>
          </a>
          <a href="javascript:void(0);"  data-dismiss="modal" (click)="editFile(selectedFile)" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#edit"></use>
            </svg>
            <div>Edit</div>
          </a>
          <a href="javascript:void(0);"  data-dismiss="modal" (click)="downloadFile(selectedFile)" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download</div>
          </a>
          <a href="#confirm-modal" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#trash"></use>
            </svg>
            <div>Delete</div>
          </a>
        </div>

        <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<div class="modal fade modal--alert" id="confirm-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
     aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--prorata">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/0/avatar/sad.png'" alt=""
                 class="img-fluid">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Are you sure?</h4>
            <p class="error-text"></p>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" class="button button--lg button--primary" (click)="deleteFile()" data-dismiss="modal">Yes, I am</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="error-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
     aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--prorata">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/0/avatar/sad.png'" alt=""
                 class="img-fluid">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Oops!</h4>
            <p class="error-text"></p>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" class="button button--lg button--primary" data-dismiss="modal">OK</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal modal--max modal--widest fade" id="advanced-search-modal" tabindex="-1" role="dialog" aria-labelledby="advanced-search-modal"  aria-modal="true">
  <div class="modal-dialog" role="document">
    <form class="modal-content modal-filter" id="advanced-search-form">

      <div class="modal-filter__title">
        Advanced search
        <a href="#" class="modal-filter__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>

      <div class="modal-filter__content">
        <div class="modal-filter__content-inner">

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Keyword</div>
              <div class="advanced-search-group__fields">
                <input type="text" class="form-control" id="advanced-search-keyword">
              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label">Status</div>
              <div class="advanced-search-group__fields">

                <div class="advanced-search-group__status" id="advanced-search-status-group">

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-active" value="active">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Active</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-approved" value="approved">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Approved</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-progress" value="in%20progress">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">In Progress</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-notification" value="received%20notification">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Received Notification</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-renewal" value="renewal%20due">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Renewal Due</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-declined" value="request%20declined">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Request Declined</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-underwriting" value="underwriting">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Underwriting</span>
                  </label>

                </div>


              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Date Range</div>
              <div class="advanced-search-group__fields">

                <div class="form-group mb-0">
                  <div class="form-group__daterange">
                    <div class="form-group__daterange-start">
                      <div class="form-group form-group--sm mb-0">
                        <div class="ui-datepicker__wrap">
                          <div class="form-control__wrap has-icon">
                            <input type="text" class="form-control hasDatepicker" value="" placeholder="From date" id="search-date-start" readonly=""><button type="button" class="ui-datepicker-trigger"></button>
                            <span class="form-control__icon"><svg class="icon">
                                <use xlink:href="#calendar"></use>
                              </svg></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group__daterange-to">
                      to
                    </div>
                    <div class="form-group__daterange-end">
                      <div class="form-group form-group--sm mb-0">
                        <div class="ui-datepicker__wrap">
                          <div class="form-control__wrap has-icon">
                            <input type="text" class="form-control hasDatepicker" value="" placeholder="To date" id="search-date-end" readonly=""><button type="button" class="ui-datepicker-trigger"></button>
                            <span class="form-control__icon"><svg class="icon">
                                <use xlink:href="#calendar"></use>
                              </svg></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

        



        </div>
      </div>

      <div class="modal-filter__btn">
        <a href="#" disabled="disabled" class="button button--naked button--no-min" id="advanced-search-clear">Reset</a>
        <a href="everything.b2b-dashboard-tables-result.html" disabled="disabled" class="button button--primary" id="advanced-search-submit">Search</a>
      </div>

    </form>
  </div>
</div>
<div id="filters" class="filters">
  <div class="filters__inner">
    <div class="filters__header">
      <h5>Filters</h5>
      <a href="#" class="filters__header-close" data-close="filter">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>
    </div>
    <div class="filters__body">

      <div class="filter-accordion">
        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-1" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Filter standard</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-1" class="filter-accordion__body collapse" style="">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>


              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">A Label</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">B Label</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">C Label</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" checked="checked">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-2" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Brokerage</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-2" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="everything" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-1">E</span>
                      </div>
                      Everything.Insure
                    </span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="first" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-2">FE</span>
                      </div>
                      First Equity
                    </span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="reef" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-3">RI</span>
                      </div>
                      REEF Insurance
                    </span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="quality" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-5">QF</span>
                      </div>
                      Quality First
                    </span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="acme" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-4">AC</span>
                      </div>
                      Acme &amp; Co
                    </span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" value="bifco" name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-9">BE</span>
                      </div>
                      Biffco Enterprise
                    </span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <a href="#filter-item-3" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Filter type radios</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-3" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" name="radio-filter" checked="">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Label</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" name="radio-filter">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Label</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" name="radio-filter">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Label</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>




        <div class="filter-accordion__item">
          <div class="filter-accordion__parent">
            <strong>Filter type parent</strong>
          </div>
          <div class="filter-accordion__item">
            <div class="filter-accordion__header">
              <a href="#filter-item-4a" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                <div class="filter-accordion__title-text">Classes example</div>
                <span class="filter-accordion__title-indi">
                  <svg class="icon">
                    <use xlink:href="#minus"></use>
                  </svg>
                  <svg class="icon">
                    <use xlink:href="#plus"></use>
                  </svg>
                </span>
              </a>
            </div>
            <div id="filter-item-4a" class="filter-accordion__body collapse">
              <div class="filter-accordion__content">

                <div class="filter-accordion__search">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                      <div class="input-group-append">
                        <span class="input-group-icon">
                          <svg class="icon">
                            <use xlink:href="#search"></use>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <ul class="filter-accordion__list">
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Product</span>
                    </label>
                  </li>
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Product</span>
                    </label>
                  </li>
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Product</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="filter-accordion__item">
            <div class="filter-accordion__header">
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox">
                <span class="custom-input__indi"></span>
              </label>
              <a href="#filter-item-4b" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                <div class="filter-accordion__title-text">Filter standard within parent</div>
                <span class="filter-accordion__title-indi">
                  <svg class="icon">
                    <use xlink:href="#minus"></use>
                  </svg>
                  <svg class="icon">
                    <use xlink:href="#plus"></use>
                  </svg>
                </span>
              </a>
            </div>
            <div id="filter-item-4b" class="filter-accordion__body filter-accordion__body--indent collapse">
              <div class="filter-accordion__content">

                <div class="filter-accordion__search">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text" value="" placeholder="Search by [filter]" class="form-control" data-input="search-filter">
                      <div class="input-group-append">
                        <span class="input-group-icon">
                          <svg class="icon">
                            <use xlink:href="#search"></use>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <ul class="filter-accordion__list">
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Label</span>
                    </label>
                  </li>
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Label</span>
                    </label>
                  </li>
                  <li>
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">Label</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>


      </div>


    </div>
    <div class="filters__tray">
      <a href="#" id="filters-reset-btn" class="button button--block button--secondary">Reset</a>
      <a href="#" id="filters-apply-btn" class="button button--block button--primary">Apply</a>
    </div>
  </div>
</div>
